import Button from "@app/components/button";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import AuthService from "@app/services/http/auth.service";
import { ChangePasswordInitialValues } from "@app/types";
import { changePasswordValidationSchema } from "@app/validations";
import useObservable from "@core/hooks/use-observable.hook";
import { Form, Formik, FormikContextType } from "formik";
import { createRef } from "react";

function ChangePasswordPage() {
  const formRef = createRef<FormikContextType<ChangePasswordInitialValues>>();
  const { subscribeOnce } = useObservable();

  const handleSubmit = (values: ChangePasswordInitialValues) => {
    subscribeOnce(AuthService.changePassword(values), (res) => {
      if (res) {
        formRef.current?.resetForm();
        alert("Đổi mật khẩu thành công!");
      } else {
        alert("Đổi mật khẩu thất bại!");
      }
    });
  };

  return (
    <div className="w-96 mx-auto mt-20">
      <Formik
        initialValues={{ oldPassword: "", password: "", confirmPassword: "" }}
        onSubmit={handleSubmit}
        innerRef={formRef}
        validationSchema={changePasswordValidationSchema}
        validateOnChange
        validateOnBlur
      >
        <Form>
          <FormControl name="oldPassword">
            <h1>Nhập mật khẩu cũ</h1>
            <Input
              width="auto"
              className="!w-[98%] !max-w-none mb-[22px]"
              inputClassName="!rounded !border-[#DCDFE6] h-[40px] leading-[40px] text-sm text-[#606266]"
              placeholder="Nhập mật khẩu cũ..."
              inputElement={<i className="fa fa-user text-[#c0c4cc]"></i>}
              errorClassName="text-[#F56C6C] text-xs"
            />
          </FormControl>
          <FormControl name="password">
            <h1>Nhập mật khẩu mới</h1>
            <Input
              width="auto"
              className="!w-[98%] !max-w-none mb-[22px]"
              inputClassName="!rounded !border-[#DCDFE6] h-[40px] leading-[40px] text-sm text-[#606266]"
              placeholder="Nhập mật khẩu..."
              inputElement={<i className="fa fa-lock text-[#c0c4cc]"></i>}
              errorClassName="text-[#F56C6C] text-xs"
              type="password"
            />
          </FormControl>
          <FormControl name="confirmPassword">
            <h1>Nhập lại mật khẩu</h1>
            <Input
              width="auto"
              className="!w-[98%] !max-w-none mb-[22px]"
              inputClassName="!rounded !border-[#DCDFE6] h-[40px] leading-[40px] text-sm text-[#606266]"
              placeholder="Nhập lại mật khẩu..."
              inputElement={<i className="fa fa-lock text-[#c0c4cc]"></i>}
              errorClassName="text-[#F56C6C] text-xs"
              type="password"
            />
          </FormControl>
          <Button
            type="submit"
            width="auto"
            size="m"
            containerClassName="mt-7 max-sm:!mt-3"
            label="Đổi mật khẩu"
            className="text-sm rounded-[20px] bg-[#fcd535] border-[#181e25] hover:bg-[#181e25] hover:border-[#181e25]"
            labelClassName="font-medium"
          />
        </Form>
      </Formik>
    </div>
  );
}

export default ChangePasswordPage;
